import { $ } from '@/libs/jquery/index'

interface ISelectorNode {
  selector: string
}

$.validator.addMethod('dependsall', (value: string, element: HTMLElement, params: ISelectorNode): boolean => {
  const isFilled = $(`[data-selector="${params.selector}"]`)
    .map((index, item) => $(item).val().toString())
    .filter((item) => !!item).length > 0

  return isFilled && !!value
}, 'Поле, обязательное к заполнению.')
